import { Box, Grid, Collapse, useTheme, Typography, ToggleButton, Link, useMediaQuery } from "@mui/material";
import Header from "../../common/Header";
import Card from "../../common/Card";
import Button from "../../common/Button";
import { AddCircleOutlineOutlined, AppRegistrationOutlined, AssessmentOutlined,TransferWithinAStationTwoTone, BorderColorOutlined, DeleteOutlineOutlined, ListAltOutlined, ManageAccountsOutlined, ModeOutlined, PendingActionsOutlined, RuleFolder, RuleFolderOutlined, SearchOutlined, TrackChanges, TroubleshootOutlined, VerifiedUserOutlined, Wysiwyg, MobileFriendlyOutlined, CloudDownload, ExitToApp, KeyboardArrowDown, DownloadOutlined, ToggleOn as ToggleOnIcon, Cancel } from "@mui/icons-material";
import Table, { Row } from "../../common/CustomTable";
import { useLocation, useNavigate } from "react-router-dom";
import { usePracticeSlice } from "../../../redux/slice/practiceSlice";
import { useEffect, useMemo,  useState } from "react";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { useForm } from "react-hook-form";
import { formatAddress, fullName, getCategoryDisplayLabel, hideElement, sortNames } from "../../../utils/Utility";
import { createListSort } from "../../../utils/listSort";
import { setSingleAlertObj, showHideLoadingDialog, SingleAlertInfo } from "../../../redux/slice/commonSlice";
import CustomIconButton from "../../common/CustomIconButton";
import { CAN_ACCESS_APPLICATION, IVR_STATUS, ORDERTYPE, PATIENT_LIST_ACTIONS, PATIENT_STATUS, USER_ROLES, PRACTICE_SPECIALIZATION, PRACTICE_TYPE, USER_ROLE_ENTITY_NAMES, AUDIT_ENTITYS, PRODUCT_CATEGORY, CREATE_PATIENT_FLOW_SOURCE, PRODUCT_CATEGORY_CODETABLE } from "../../../constants/applicationConstants";
import { getSearchCriteriaFromSessionStorage, saveSelectionForPage, setSearchCriteriaToSessionStorage } from "../../../utils/StorageUtils";
import { PracticeInfo } from "../../../redux/slice/practice/practiceRegistrationSlice";
import { getPracticesByUserRoleUserSlice, resetUserState, useUserReducer } from "../../../redux/slice/userSlice";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import { selectIsTokenAvailable, selectIsValueFoundInToken, useAuthSlice } from "../../../redux/slice/authSlice";
import CustomTextField from "../../common/CustomTextField";
import { checkPatientEligibilty, deletePatient, getPatient, PatientInfo, resetSearchPatientList, SearchPatientRequest, searchPatients, updatePatientObjectReducer, usePatientReducer,changePatientStatus } from "../../../redux/slice/patient/patientSlice";
import IVRPracticeSelectionPopup from "../ivr/IVRPracticeSelectionPopup";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
// import CreateOrderPopupForPatients from "../orders/CreateOrderPopupForPatients";
import OptionsPopup, { OptionPopupObjectProps } from "../../common/OptionsPopup";
import { checkAgreementsForPracticeBasedOnProductType, checkAncilliaryAgreementsForPractice } from "../../../redux/slice/productAgreement/createAgreementSlice";
import CreateOrderIVRListPopup from "../orders/CreateOrderIVRListPopup";
import { searchIVRByPatientId, SearchIVRListRequest } from "../../../redux/slice/ivr/createIVRSlice";
import { getOrderItemsByOrderId, getOrdersByPatientId, OrderInfo, SearchOrder } from "../../../redux/slice/order/OrderSlice";
import InfoPopup from "../../common/InfoPopup";
import RecordPastOrderPopup from "../orders/RecordPastOrderPopup";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import PatientEligibilityPopUp from "./PatientEligibilityPopUp";
import { unwrapResult } from "@reduxjs/toolkit";
import { OrderItemRow } from "../orders/TissueTrackingForMultipleOrders";
import { date } from "yup";
//CS-1244
import AddPatientEmrPopup from "../../common/AddPatientEMRPopup";
import { is } from "date-fns/locale";

import { EXPORTABLE_ITEMS } from '../../../constants/applicationConstants'; //cs-1700
import ExportToExcel from '../../common/ExportToExcel'; //cs-1700
import StyledMenu from '../../common/StyledMenu'; //cs-1700
import WarningPopup, { WarningPopupObjectProps } from "../../common/WarningPopup"; //CS-1700
import WarningPopupNew, { WarningPopupNewObjectProps } from "../../common/WarningPopupNew";
import CompletePracticeRegistrationModal from "../account/CompletePracticeRegistrationModal";
import { FileText } from "lucide-react";
import FacesheetExtractionPopup from "../aiMedicalAudit/FacesheetExtractionPopup";
import AddNewPatientPopup from "./AddNewPatientPopup"; // CS-1758
import { keyframes } from "@mui/system";
import { useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import { useModalStyles } from "../../common/useModalStyles";
// CS-2075 START
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";
import PatientRequestRx, { RequestRxPatient } from "../prescription/PatientRequestRx";
// CS-2075 END

interface Column {
  id: string;
  label: string;
  minWidth?: number;
  align?: "right" | "center" | "left"; // Adjust the align property type
  format?: (value: number) => string;
}

type Option = {
  value: string,
  label: string
};






const ITEMS_PER_PAGE = 20;

const patientListSort = createListSort(
  ["patientCode", "patientName", "practiceName", "birthDate", "dateOfSurgery", "status"] as const,
  {
    patientCodeLink: "patientCode",
    patientName: "patientName",
    practiceName: "practiceName",
    birthDate: "birthDate",
    dateOfSurgery: "dateOfSurgery",
    status: "status",
  }
);

const moveGradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;


const PatientsList = () => {




  const handleAlert = (message: string, type: "success" | "error" | "info") => {
    const alertObj: SingleAlertInfo = {
      message,
      alertType: type,
    };
    dispatch(setSingleAlertObj(alertObj));
  };

  const location = useLocation();
  const { navigate } = useNavigation();
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const { primaryBtnSx, tokens: modalTokens } = useModalStyles();

  const { control, handleSubmit, reset, setValue } = useForm<SearchPatientRequest>();

  const [searchCriteria, setSearchCriteria] = useState<SearchPatientRequest>({
    practiceIds: [],
    firstName: "",
    lastName: "",
    patientStatus: [],
    isSurgicalPracticesAvailable: false,
    // primaryInsurance: "",
    // secondaryInsurance: "",
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE,
  });

  const { userInfo } = useAuthSlice();
  const { allCodeTablesValuesMap } = useCodetablesSlice();
  const { practiceByUserRoleUserSlice } = useUserReducer();
  const { searchPatientList } = usePatientReducer();
  const [showIVRSelectionPopup, setShowIVRSelectionPopup] = useState(false);
  const [showCreateOrderPopup, setShowCreateOrderPopup] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState<{ patientId: number, practiceId: number, practiceName?: string | null, providerId?: number | null } | null>(null);
  const [selectedPatientData, setSelectedPatienData] = useState<any>({});
  const [confirmDeleteOptionPopup, setConfirmDeleteOptionPopup] = useState(false);
  const [showInfoPopup, setShowInfoPopup] = useState<{ message: string, show: boolean, title: string }>({ message: "", show: false, title: "" });
  const [showEligibilityPopup, setShowEligibilityPopup] = useState(false);
  const canCreatePatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_PATIENT)(state));
  const canEditPatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.EDIT)(state));
  const canAccessBenefitVerification = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.PVERIFY)(state));
  const canDeletePatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.DELETE)(state));
  const canCreateOrder = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_ORDER)(state));
  const canClosePatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CLOSE_PATIENT)(state));
  const canReOpenPatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.REOPEN_PATIENT)(state));
  //Start CS-1700
  const canExportPatients = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORTABLE_ITEMS.PATIENTS)(state));
  const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  //Start CS-1700
  const canAuditPatient = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessAuditAction", AUDIT_ENTITYS.PATIENTAUDIT)(state));

  // CS-925
  const canRecordPastOrder = useSelector((state: RootState) => selectIsTokenAvailable("canRecordPastOrder")(state));
  const canCreateIVR = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.CREATE_IVR)(state));
  const canViewDetails = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.VIEW_DETAILS)(state));
  const canRecordTX = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.RECORD_TX)(state));
  // CS-2075 START
  const canRequestRx = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPatientActions", PATIENT_LIST_ACTIONS.REQUEST_RX)(state));
  const [rxPatient, setRxPatient] = useState<RequestRxPatient | null>(null);
  // CS-2075 END
  const [showIVRListPopup, setShowIVRListPopup] = useState(false);
  const [showRecordPastOrderPopup, setShowRecordPastOrderPopup] = useState(false);
  const[patientData,setPatientData] = useState<any>(null);
  const [showAncillaryForm,setShowAncillaryForm] = useState(false);
  const [verifyBenefitClick,setVerifyBenefitClick] =useState(false) 
  const [showCreateIvrPopup, setCreateIvrPopup] = useState<{message:string, show: boolean, title: string}>({message: "", show: false, title: "" });
  //CS-1071 - Start
  const [activeButtonId, setActiveButtonId] = useState<string | null>(null);
//CS-1071 - End
//CS-1148 - Start
const [createdPatientData,setCreatepatientData] = useState<any>(null);
//CS-1148 - End
  const [showOptionPopup, setShowOptionsPopup] = useState<OptionPopupObjectProps>({ message: '', show: false });
  const [showPHIWarning, setShowPHIWarning] = useState<WarningPopupObjectProps>({ show: false, message: '' }); //CS-1700
  //CS-1244 - Start
  const [openPracticePopup, setOpenPracticePopup] = useState<boolean>(false);
  //CS-1244 - End
  const [ loadingComplete, setLoadingComplete ] = useState<Boolean>(false);
  //Mount

 const isSurgicalPracticesAvailable = useMemo(() => {
    return practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
      ? practiceByUserRoleUserSlice?.some(practice => practice.specialization === PRACTICE_TYPE.SURGICAL) :false;
}, [practiceByUserRoleUserSlice]);
  const isRestrictedUser = userInfo.userRole === USER_ROLES.ROLE_PRACTICE_USER_PRU;
  const [showPRUWarning, setShowPRUWarning] = useState<WarningPopupNewObjectProps>({ show: false, message: '' });
  const [registrationModalOpen, setRegistrationModalOpen] = useState(false);
  const [showCard, setShowCard] = useState(!isRestrictedUser);
  const {
    filterPanelRef,
    toggleFilterPanel,
    handleFilterPanelEntering,
    handleFilterPanelEntered,
    handleFilterPanelExited,
  } = useFilterPanelFocus(showCard, setShowCard);
//CS-1758
const canCreatePatientUsingFaceSheet = useSelector((state: RootState) => selectIsTokenAvailable("canCreatePatientUsingFaceSheet")(state));
const [showAddNewPatientPopup, setShowAddNewPatientPopup] = useState(false); // CS-1758
const columns: Column[] = [
  // { id: "patientCode", label: "Patient ID", minWidth: 100 },
  { id: "patientCodeLink", label: "Patient ID", minWidth: 100 }, //CS-1406 - rendering patiend code with link
  { id: "patientName", label: "Patient Name", minWidth: 100 },
  { id: "practiceName", label: "Practice Name", minWidth: 100 },
  { id: "birthDate", label: "DOB", minWidth: 150 },
    ...(isSurgicalPracticesAvailable 
    ? [{ id: "dateOfSurgery", label: "Date of Surgery", minWidth: 120 }]
    : []),
  { id: "status", label: "Status", minWidth: 150 },
  {
    id: "action",
    label: "Action", // Rename the column to "Action"
    minWidth: 100, // Align the button to the right
  },
];

  const withPRUGuard = (fn: () => void) => () => {
    if (isRestrictedUser) {
      setShowPRUWarning({
        show: true,
        title: "Pre Registered User Warning",
        message: (
          <center>
            {isRestrictedUser && userInfo.associatedPracticeStatus === "PENDING"
              ?
              "You don't have access to this feature. Please complete the practice registration in order to use the full system functionality."
              : "Your practice submission is pending approval. Full access to the system will be granted once it has been reviewed and approved."}
          </center>
        ),
        variant: "warning",
        buttons: [
          ...(isRestrictedUser && userInfo.associatedPracticeStatus === "PENDING"
            ? [
              {
                name: "Cancel",
                color: "error" as const,
                icon: <Cancel sx={{ fontSize: "1rem" }} />,
                onClick: () => setShowPRUWarning({ show: false, message: '' }),
              },
            ]
            : [
              {
                name: "OK",
                color: "success" as const,
                onClick: () => setShowPRUWarning({ show: false, message: '' }),
              },
            ]),
          ...(isRestrictedUser && userInfo.associatedPracticeStatus === "PENDING"
            ? [
              {
                name: "Complete Registration",
                color: "success" as const,
                onClick: () => {
                  setRegistrationModalOpen(true);
                  setShowPRUWarning({ show: false, message: "" });
                },
              },
            ]
            : []),
        ],
      });
      return;
    }
    fn();
  };

  //CS-1071 - Start
  useEffect(() => {
    dispatch(showHideLoadingDialog(true))
    const saved = sessionStorage.getItem("activeActionButtonId");
    if (saved) {
      setActiveButtonId(saved);
    }
  }, []);
  //CS-1071 - End
  //Unmount
  useEffect(() => () => {
    dispatch(resetSearchPatientList());
    dispatch(resetUserState());
  }, []);

  useEffect(() => {
    if(showAncillaryForm && patientData?.firstName && patientData?.lastName){
      navigate("/ancillaryorder", { state: { orderType: ORDERTYPE.DIRECT_ORDER_WITHOUT_IVR ,practiceId:selectedPatient?.practiceId,practiceName:selectedPatient?.practiceName ,patientId:selectedPatient?.patientId ,patientData:patientData } })
    }
  },[showAncillaryForm ,patientData])
//   useEffect(() => {
//     if (patientData?.patientInfo && verifyBenefitClick) {
//       const selectedInsuranceData = patientData.patientInfo.find(
//         (patient: any) =>
//           patient?.inactiveDate === null &&
//         patient?.infoType === "PRIMARY_INSURANCE"
//       );
//         if (selectedInsuranceData && selectedInsuranceData?.patientinfoData?.insuranceName && selectedInsuranceData?.patientinfoData?.insurancePayerCode && selectedInsuranceData?.patientinfoData?.policy ) {
//           setShowEligibilityPopup(true);
//         } else {
//            const alertObj: SingleAlertInfo = {
//                   message: "Eligibility check is not available for manually entered insurance providers.",
//                   // message: "To initiate insurance verification through our third-party provider, pVerify, please navigate to the patient details page and update the insurance information.",
//                   alertType: "error",
//                 };
//                 dispatch(setSingleAlertObj(alertObj));
//           setVerifyBenefitClick(false);
//           setPatientData(null);
//           setSelectedPatient(null);
//         }
//     }
// }, [patientData,verifyBenefitClick]);
  const practiceIdsKey = useMemo(
    () => (practiceByUserRoleUserSlice ?? []).map((practice: any) => practice.practiceId).join(","),
    [practiceByUserRoleUserSlice]
  ); // CS-2075
  useEffect(() => {
    //1. When login another user pagination is remain in the history and can redirect that page
    //CS-1404 - Token value change to PATIENT from practice 
    let criteria = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.PATIENT + "SearchCriteria" + userInfo.userId);
    if ((location.state && location.state?.patientListSearchCriteria) || (location.state && location.state.withSearchHistory && criteria)) {
      if (location.state && location.state.withSearchHistory) {
        //Below navigate line call back to this useEffect - This for refreshing issue when navigate with state.withSearchHistory=true
        navigate("/patients", { state: { patientListSearchCriteria: criteria } });
        return;
      }
      let searchCriteria: SearchPatientRequest = {
        practiceIds: [],
        firstName: "",
        lastName: "",
        patientStatus: [],
        isSurgicalPracticesAvailable: false,
        // primaryInsurance: "",
        // secondaryInsurance: "",
        currentPage: 0,
        itemsPerPage: 0
      };
      if (location.state && location.state.patientListSearchCriteria) {
        searchCriteria = location.state.patientListSearchCriteria;
      } else {
        searchCriteria = criteria ? criteria : searchCriteria;
      }
      setSearchCriteria(searchCriteria);
      setValuesToCriteriaFields(searchCriteria);

      if(practiceByUserRoleUserSlice && practiceByUserRoleUserSlice?.length > 0){
        searchPracticesList(searchCriteria);
      }
    } else {
      if(practiceByUserRoleUserSlice && practiceByUserRoleUserSlice?.length > 0){
        if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
          loadInitialPracticeList(1);
        }
      }
    }
  // }, [location.state, practiceByUserRoleUserSlice]);
  // CS-2075 — key on practice ids: a same-list refresh (e.g. the Request Rx modal reloading practices) re-ran searchPatient.
  }, [location.state, practiceIdsKey]);
  //CS-1148 - Start
  useEffect(() => {
    if (location?.state?.openCreateIvrPopup) {
      setPatientNavigationPopup()
      setCreatepatientData({patientId:location?.state?.patientId, practiceId: location?.state?.practiceId})
      navigate(location.pathname, { replace: true });
    }
  }, [location?.state])
  const setPatientNavigationPopup = () => {
    setCreateIvrPopup({
      message: 'Patient details are received. Please proceed to create IVR',
      show: true,
      title: "Create IVR"
    });
  };
  //CS-1148 - End
  const setValuesToCriteriaFields = (searchCriteria: SearchPatientRequest) => {
    setValue("practiceIds", searchCriteria.practiceIds);
    setValue("firstName", searchCriteria.firstName);
    setValue("lastName", searchCriteria.lastName);
    setValue("patientStatus", searchCriteria.patientStatus);
    // setValue("primaryInsurance", searchCriteria.primaryInsurance);
    // setValue("secondaryInsurance", searchCriteria.secondaryInsurance);
  }
  const loadInitialPracticeList = (pNumber: number = 1) => {
    const practiceIdList = practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
      ? practiceByUserRoleUserSlice?.map(practice => Number(practice.practiceId)) : [];
    const data: SearchPatientRequest = {
      practiceIds: practiceIdList && practiceIdList.length === 1 ? practiceIdList : [],
      firstName: "",
      lastName: "",
      patientStatus: [],
      // primaryInsurance: "",
      // secondaryInsurance: "",
      isSurgicalPracticesAvailable: isSurgicalPracticesAvailable,
      currentPage: pNumber,
      itemsPerPage: ITEMS_PER_PAGE,
    };
    setSearchCriteria(data);
    setValuesToCriteriaFields(data);

    searchPracticesList(data);
  }

  const searchPracticesList = (searchCriteria: SearchPatientRequest) => {
    const normalizedCriteria = patientListSort.normalize(searchCriteria);
    // CS-1404 - Save original search criteria to session storage
    setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.PATIENT + "SearchCriteria" + userInfo.userId, normalizedCriteria);
    let dataToSearch = {
      ...normalizedCriteria
    }
    if (!dataToSearch.practiceIds || dataToSearch.practiceIds.length === 0) {
      dataToSearch.practiceIds = practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
        ? practiceByUserRoleUserSlice?.map(practice => Number(practice.practiceId)) : [];
    }

    // setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.PATIENT + "SearchCriteria" + userInfo.userId, dataToSearch);
    dispatch(searchPatients(dataToSearch));
  }

  const handleClickPatientAudit = (data: any) => {
    if (data && data?.patientName) {
      const PatientAuditData = {
        entityName: "PATIENT",
        entityNumber: data?.patientName,
      }
      const path = `/auditlog?entityName=${PatientAuditData.entityName}&entityNumber=${PatientAuditData.entityNumber}`;
      window.open(path, '_blank');
    }
  }
 
  const handleClose = () => {
    setShowIVRListPopup(false);
    dispatch(updatePatientObjectReducer(null));
  };

  const handleRecordPastOrderPopup = () => {
    setShowRecordPastOrderPopup(!showRecordPastOrderPopup);
  }
  const onSubmit = (data: SearchPatientRequest) => {
    const data2: SearchPatientRequest = {
      practiceIds: data.practiceIds,
      firstName: data.firstName,
      lastName: data.lastName,
      patientStatus: data.patientStatus,
      // primaryInsurance: data.primaryInsurance,
      // secondaryInsurance: data.secondaryInsurance,
      isSurgicalPracticesAvailable: data.isSurgicalPracticesAvailable,
      currentPage: 1,
      itemsPerPage: ITEMS_PER_PAGE,
      ...patientListSort.pick(searchCriteria),
    }
    setSearchCriteria(data2);
    //Below navigate line call to useEffect[location.state] and search
    navigate("/patients", { state: { patientListSearchCriteria: data2 } });
  }
  const fetchPatientById = async () => {
    try {
      if(selectedPatient?.patientId){
        const response = await dispatch(getPatient({ patientId: selectedPatient?.patientId.toString()  })).unwrap();
        setPatientData(response.data);
      }
    } catch (error) {
      console.error("Error fetching patient data:", error);
    }
  };
  useEffect(()=>{
    if(selectedPatient?.patientId){
      fetchPatientById();
    }
  },[selectedPatient?.patientId])
  const handlePagination = (pageNumber: number) => {
    const data = {
      ...searchCriteria,
      currentPage: pageNumber + 1
    }
    setSearchCriteria(data);

    //Below navigate line call to useEffect[location.state] and search
    navigate("/patients", { state: { patientListSearchCriteria: data } });
  }

  const handleTableSort = (columnId: string, order: "asc" | "desc") => {
    const data = patientListSort.withSort(searchCriteria, columnId, order);
    if (!data) {
      return;
    }
    setSearchCriteria(data);
    navigate("/patients", { state: { patientListSearchCriteria: data } });
  }

  const formattedPatientRows = useMemo(() => {
    const rows: PatientInfo[] = [];
    searchPatientList?.content.forEach(patient => {
      const patientAddressInfo = patient.addressInfo;
      const row = {
        ...patient,
        //CS-1406 - Integrated patient code clickable to open details page
        patientCodeLink: patient.patientId !== null && canViewDetails ? (
          <Link
            component="button"
            underline="hover"
            variant="body2"
            onClick={(e) => { 
              e.stopPropagation(); handleActionButtonClick(`patientListActionButton-${patient.patientId}`, () =>{navigate('/patientDetails', { state: { patientDetails: { patientId: patient.patientId ,patientName:patient.patientName ,dob:patient.birthDate } } })})}} // CS-1555
            color={'#00B8D9'}
          >
            {patient.patientCode}
          </Link>
        ) : (
          patient.patientCode
        ),
        patientName: fullName(null, patient.firstName, patient.middleName, patient.lastName),
        dateOfSurgery: isSurgicalPracticesAvailable && patient.dateOfSurgery!== null ? patient.dateOfSurgery : "-",
        status: patient.status ,
        address: formatAddress(
          patientAddressInfo?.patientStreetAddress,
          patientAddressInfo?.patientUnitNumber,
          patientAddressInfo?.patientCity,
          patientAddressInfo?.patientState,
          patientAddressInfo?.patientZip
        )
      }
      rows.push(row)
    })
    return rows;
  }, [searchPatientList]);

  const onCreateIVRClick = async (row: PatientInfo) => {
    if (row.status === PATIENT_STATUS.DRAFTED) {
      setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create IVR" })
    } else {
      if (row.practiceId) {
        const response = await dispatch(checkAncilliaryAgreementsForPractice(row.practiceId));
        if (userInfo?.entityName !== USER_ROLE_ENTITY_NAMES.ADMIN && canCreateIVR) {
          navigate("/ivr", {
            state: {
              practiceId: row.practiceId,
              ivrEmailNotification: true,
              patientData: { from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: row.patientId },
              // CS-1728 - Replacing static label to dynamic constant
              productCategory: response.payload === true ? PRODUCT_CATEGORY.CONSERVATIVE : PRODUCT_CATEGORY.ADVANCED,
            }
          });
        } else {
          setShowIVRSelectionPopup(true);
        }
      }
      setSelectedPatient({
        patientId: row.patientId || 0,
        practiceId: row.practiceId || 0
      });
    }
  }
  const onCreateOrderClick = async (row: PatientInfo) => {
    setSelectedPatient({
      patientId: row.patientId || 0,
      practiceId: row.practiceId || 0,
      practiceName: row.practiceName,
      providerId: row.providerId
    })
    setSelectedPatienData({
      firstName: row.firstName,
      middleName: row.middleName,
      lastName: row.lastName,
      dob: row.birthDate,
      gender: row.gender
    })
    if (row.status === PATIENT_STATUS.DRAFTED) {
      setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create Order" })
    } else {
      if (row.practiceId) {
        const response = await dispatch(checkAgreementsForPracticeBasedOnProductType(row.practiceId));
        if (response?.payload && response?.payload?.hasAdvancedCTPsAgreement === true && response?.payload?.hasAncilliaryAgreement === true) {
          setShowIVRListPopup(true);
          setSelectedPatient({
            patientId: row.patientId || 0,
            practiceId: row.practiceId || 0,
            practiceName: row.practiceName
          })
          setSelectedPatienData({
            firstName: row.firstName,
            middleName: row.middleName,
            lastName: row.lastName,
            dob: row.birthDate,
            gender: row.gender
          })
        } else if (response?.payload && response?.payload?.hasAdvancedCTPsAgreement === true && response?.payload?.hasAncilliaryAgreement === false ) {
          setShowIVRListPopup(true);
          setSelectedPatient({
            patientId: row.patientId || 0,
            practiceId: row.practiceId || 0,
            practiceName: row.practiceName
          })
          setSelectedPatienData({
            firstName: row.firstName,
            middleName: row.middleName,
            lastName: row.lastName,
            dob: row.birthDate,
            gender: row.gender
          })
        } else if (response?.payload && response?.payload?.hasAdvancedCTPsAgreement === false && response?.payload?.hasAncilliaryAgreement === true ) {
          // setShowAncillaryForm(true);
          setShowIVRListPopup(true);
        } else {
          const alertObj: SingleAlertInfo = {
            message: "There is no active agreement found. You can not create order.",
            alertType: "error",
          };
          dispatch(setSingleAlertObj(alertObj));
        }
      }
    }
  }
  const onVerifyBenefitClick = async (row: PatientInfo) => {
    setSelectedPatient({
      patientId: row.patientId || 0,
      practiceId: row.practiceId || 0,
      practiceName: row.practiceName
    })
    // setVerifyBenefitClick(true)
    setShowEligibilityPopup(true);

  }

  /* istanbul ignore next -- never-used declaration: its only call site (the "View IVRs" button) is commented out */
  const onViewOldIVRClick = async (row: PatientInfo) => {
    if (row.practiceId) {
      let searchCriteriaIvr: SearchIVRListRequest = {
        productId: [],
        practiceId: [],
        productCategory: [],
        patientFirstName: row.firstName,
        patientLastName: row.lastName,
        verificationStatus: [],
        ivrNumber: '',
        fromDate: "",
        toDate: "",
        patientId: row.patientId,
        currentPage: 1,
        itemsPerPage: ITEMS_PER_PAGE
      };
      navigate("/ivr_list", { state: { ivrListSearchCriteria: searchCriteriaIvr } })
    }
  }

  // const onViewOldOrderClick = async (row: PatientInfo) => {
  //   if (row.practiceId) {
  //     let searchCriteriaOrder: SearchOrder = {
  //       practiceIds: [],
  //       manufacturerIds: [],
  //       patientFirstName: row.firstName,
  //       patientLastName: row.lastName,
  //       productIds: [],
  //       providerName: "",
  //       orderNumber: "",
  //       invoiceNumber: "",
  //       fromDate: "",
  //       toDate: "",
  //       status: [],
  //       invoiceStatus: [],
  //       currentPage: 1,
  //       itemsPerPage: ITEMS_PER_PAGE,
  //       downloadState: false,
  //       fromServiceDate: '',
  //       toServiceDate: '',
  //       patientId: row.patientId
  //     };
  //     navigate("/order_list", { state: { orderListSearchCriteria: searchCriteriaOrder } });
  //   }
  // }
  //CS-1071 - Start
  const handleActionButtonClick = (buttonId: string, originalClick: () => void) => {
    const currentPageKey = "patientList"; // Or dynamically set this value based on the current page
    saveSelectionForPage(currentPageKey, buttonId);
    setActiveButtonId(buttonId);
    sessionStorage.setItem("activeActionButtonId", buttonId);
    originalClick(); // Call the button's actual logic
  };

  const handleChangeStatusToClosed = async (row: PatientInfo) => {
    const response = await dispatch(changePatientStatus({ patientId:row.patientId, status: PATIENT_STATUS.CLOSED}));
    if (response.meta.requestStatus === 'fulfilled') {
        handleAlert("Patient record closed successfully", "success");
        const updatedCriteria = { ...searchCriteria, currentPage: 1 };
        setSearchCriteria(updatedCriteria);
        searchPracticesList(updatedCriteria);
      }
      setShowOptionsPopup({ show: false, message: "" });
    }
    
    const handleChangeStatusToActivate = async (row: PatientInfo) => {
      const response = await dispatch(changePatientStatus({ patientId:row.patientId, status: PATIENT_STATUS.ACTIVE}));
      if (response.meta.requestStatus === 'fulfilled') {
        handleAlert("Patient record activated successfully", "success");
        const updatedCriteria = { ...searchCriteria, currentPage: 1 };
        setSearchCriteria(updatedCriteria);
        searchPracticesList(updatedCriteria);
      }
      setShowOptionsPopup({ show: false, message: "" });
    }
  const handleClosePatient=(row:PatientInfo)=>{
        setShowOptionsPopup({
            message: `Do you really want to close the patient record ?`,
            show: true,
            variant: "confirm",
            buttons: [{ name: "Confirm", color: 'primary', onClick: () => handleChangeStatusToClosed(row) }, { name: "Cancel", color: 'secondary', onClick:()=> setShowOptionsPopup({ show: false, message: "" })}]
        });
  }
  const handleActivatePatient=(row:PatientInfo)=>{
        setShowOptionsPopup({
            message: `Do you really want to reactivate the patient record ?`,
            show: true,
            variant: "confirm",
            buttons: [{ name: "Confirm", color: 'primary', onClick: () => handleChangeStatusToActivate(row) }, { name: "Cancel", color: 'secondary', onClick:()=> setShowOptionsPopup({ show: false, message: "" })}]
        });
  }

  //Start CS-1700

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElMenu(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorElMenu(null);
  };

  const handleExport = (exportType: string) => {
    if (searchCriteria) {
      let dataToSearch = {
        ...searchCriteria,
        currentPage: searchCriteria.currentPage,
        downloadState: true
      }

      if (!dataToSearch.practiceIds || dataToSearch.practiceIds.length === 0) {
        dataToSearch.practiceIds = practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0
          ? practiceByUserRoleUserSlice?.map(practice => Number(practice.practiceId)) : [];
      }

      ExportToExcel(
        dataToSearch,
        columns,
        dispatch,
        exportType === "details" ? EXPORTABLE_ITEMS.PATIENT_DETAILS : EXPORTABLE_ITEMS.PATIENTS,
      )
    }
    handleMenuClose();
  }
  //End CS-1700

  const handleRecordTXClick = async (row: PatientInfo) => {
    const response = await dispatch(getOrdersByPatientId(row.patientId))
    if (response.payload && response.payload.code === "V3OK" && response.payload.message === "SUCCESS" &&
      (!response.payload.errors || response.payload.errors.length === 0)) {
      if (response.payload.data && response.payload.data.length > 0) {
        const ordersByPatient: OrderInfo[] = response.payload.data;
        try {
          const deliveredOrders = ordersByPatient.filter(order => order.orderStatus === 'DELIVERED');

          if (deliveredOrders.length === 0) {
            return setShowOptionsPopup({
              show: true,
              variant: "warning",
              message: (
                <>
                  <strong>No delivered orders were found:</strong> Record Tx only allows for delivered orders.
                  <br />
                  Please make sure the patient has at least one delivered order before proceeding.
                </>
              ),
              buttons: [
                {
                  name: "OK",
                  color: "warning",
                  onClick: () => {
                    setShowOptionsPopup({ show: false, message: "" });
                  },
                },
              ],
            });
          }

          const promises = deliveredOrders.map(order =>
            dispatch(getOrderItemsByOrderId(order.orderId)).then(unwrapResult)
          );
          const results = await Promise.all(promises);
          const combinedItems: OrderItemRow[] = results.flatMap(result => result.data);
          //CS-1248 - Replacing hard coded product category with constant
          const allAncillary = combinedItems.every(item => item.productCategory === PRODUCT_CATEGORY.CONSERVATIVE);
          if (combinedItems.length > 0 && allAncillary) {
            return setShowOptionsPopup({
              show: true,
              variant: "warning",
              message: (
                <>
                  <strong>Not supported:</strong> Record Tx is not supported for {getCategoryDisplayLabel(allCodeTablesValuesMap, PRODUCT_CATEGORY.CONSERVATIVE)}.
                </>
              ),
              buttons: [
                {
                  name: "OK",
                  color: "warning",
                  onClick: () => {
                    setShowOptionsPopup({ show: false, message: "" });
                  },
                },
              ],
            });
          }

          const updatedItems = combinedItems
            //CS-1248 - Replacing hard coded product category with constant
            .filter(item => item.productCategory !== PRODUCT_CATEGORY.CONSERVATIVE)
            .map(item => {
              const tissueTrackingInfo: Record<string, any> = item.tissueTrackingInfo || {};
              const woundKey = `woundData_${item.orderItemId}`;
              const woundDetails = tissueTrackingInfo[woundKey] || {};

              return {
                ...item,
                woundLocation: woundDetails?.woundLocationLabel || null,
              };
            })
            .sort((a, b) => a.units - b.units);
          navigate('/multiple_tissue_tracking', { state: { patientId: row.patientId, patientName: row.patientName, orderItems: updatedItems } })
        } catch (error) {
          return setShowOptionsPopup({
            show: true,
            variant: "error",
            message: (
              <>
                <strong>Error:</strong> An error occurred while fetching order items.
                <br />
                Please try again or contact support if the issue persists.
              </>
            ),
            buttons: [
              {
                name: "OK",
                color: "error",
                onClick: () => {
                  setShowOptionsPopup({ show: false, message: "" });
                },
              },
            ],
          });
        }
      } else {
        return setShowOptionsPopup({
          show: true,
          variant: "warning",
          message: (
            <>
              <strong>No orders were found:</strong> No orders were found for this patient.
              <br />
              Please verify the patient's information or try again.
            </>
          ),
          buttons: [
            {
              name: "OK",
              color: "warning",
              onClick: () => {
                setShowOptionsPopup({ show: false, message: "" });
              },
            },
          ],
        });
      }
    } else {
      return setShowOptionsPopup({
        show: true,
        variant: "error",
        message: (
          <>
            <strong>Error:</strong> An error occurred while fetching the orders.
            <br />
            Please try again or contact support if the issue persists.
          </>
        ),
        buttons: [
          {
            name: "OK",
            color: "error",
            onClick: () => {
              setShowOptionsPopup({ show: false, message: "" });
            },
          },
        ],
      });
    }
  }
  
  // CS-1555 - Start
  const handleRowNavigateToDetails = (row: Row) => {
    const patientRow = row as PatientInfo;
    if (!canViewDetails) return;
    handleActionButtonClick(`patientListActionButton-${patientRow.patientId}`, () => {
      navigate('/patientDetails', {
        state: { patientDetails: { patientId: patientRow.patientId, patientName: patientRow.patientName, dob: patientRow.birthDate } }
      });
    });
  };
  // CS-1555 - End

  //CS-1071 - End
  const actionComponent = (row: PatientInfo): JSX.Element => {
    return (
      <>

        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Detail"
          color="info"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canViewDetails)}` }}
          //CS-1071 - Start
          onClick={(e?: React.MouseEvent) => { if (e) e.stopPropagation(); handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => { navigate('/patientDetails', { state: { patientDetails: { patientId: row.patientId, patientName: row.patientName, dob: row.birthDate } } }) }) }} // CS-1555
        //CS-1071 - End
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton>


        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Create IVR"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canCreateIVR && row.status === PATIENT_STATUS.ACTIVE))}` }}
          // onClick={() => {
          //   navigate("/ivr", { state: { 
          //     practiceId: row.practiceId,
          //     ivrEmailNotification: false,
          //     patientData: {from : CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: row.patientId} } });
          // }}
          // onClick={() =>{ onCreateIVRClick(row)}}
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => onCreateIVRClick(row))}
        //CS-1071 - End
        >
          <ManageAccountsOutlined fontSize="small" />
        </CustomIconButton>

        {/* <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="View IVRs"
          color="success"
          size="small"
          variant="outlined"
          onClick={() => onViewOldIVRClick(row)}
        >
          <RuleFolderOutlined fontSize="small" />
        </CustomIconButton> */}
        {/* These create order button has ui for both ancillary and advanced CPT category options. */}
        {/* <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Create Ancillary Order"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canCreateOrder && row.status === PATIENT_STATUS.DRAFTED)}` }}
          onClick={() => {
            setShowCreateOrderPopup(true);
            setSelectedPatient({
              patientId: row.patientId || 0,
              practiceId: row.practiceId || 0,
              practiceName:row.practiceName
            });
            setSelectedPatienData({
              firstName: row.firstName,
              middleName: row.middleName,
              lastName: row.lastName,
              dob: row.birthDate,
              gender: row.gender
            })
            // navigate("/ancillaryorder", { state: { 
            //   practiceId: row.practiceId,practiceName: row.practiceName,patientName: row.patientName,patientId: row.patientId } });
          }}
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton> */}
        {/*  */}
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Create Order"
          color="success"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canCreateOrder && row.status === PATIENT_STATUS.ACTIVE))}` }}
          //CS-1071 - Start
          onClick={() => handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => onCreateOrderClick(row)) 
          //   {
          //   if (row.status === PATIENT_STATUS.DRAFTED) {
          //     setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create Order" })
          //   } else {
          //     setSelectedPatient({
          //       patientId: row.patientId || 0,
          //       practiceId: row.practiceId || 0,
          //       practiceName: row.practiceName
          //     })
          //     setSelectedPatienData({
          //       firstName: row.firstName,
          //       middleName: row.middleName,
          //       lastName: row.lastName,
          //       dob: row.birthDate,
          //       gender: row.gender
          //     })
          //     setShowIVRListPopup(true);
          //   }
          //   // navigate("/ancillaryorder", { state: { 
          //   //   practiceId: row.practiceId,practiceName: row.practiceName,patientName: row.patientName,patientId: row.patientId } });
          // }
        }
        //CS-1071 - End
        >
          <AppRegistrationOutlined fontSize="small" />
        </CustomIconButton>
        {/* CS - 925 */}
        {/* CS-1244 - Start */}
        {row.status !== PATIENT_STATUS.DRAFTED && (
          <CustomIconButton
            tooltipPlacement="top"
            tooltipMessage="Record Past Order"
            color="info"
            size="small"
            variant="outlined"
            style={{ display: `${hideElement(!canRecordPastOrder || row.status === PATIENT_STATUS.CLOSED )}` }}
            //CS-1071 - Start
            onClick={() => handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => {
              if (row.status === PATIENT_STATUS.DRAFTED) {
                setShowInfoPopup({ message: "Patient information is incomplete. Please complete the patient details before proceeding.", show: true, title: "Create Order" })
              } else {
                setSelectedPatient({
                  patientId: row.patientId || 0,
                  practiceId: row.practiceId || 0
                })
                setSelectedPatienData({
                  firstName: row.firstName,
                  middleName: row.middleName,
                  lastName: row.lastName,
                  dob: row.birthDate,
                  gender: row.gender
                })
                // handleRecordPastOrderPopup();
                navigate("/order", {
                  state: {
                    practiceId: row.practiceId || 0,
                    practiceName: row.practiceName || "",
                    patientId: row.patientId || 0,
                    patientData: {
                      firstName: row.firstName,
                      middleName: row.middleName,
                      lastName: row.lastName,
                      dob: row.birthDate,
                      gender: row.gender,
                    },
                    orderType: ORDERTYPE.PAST_ORDER
                  },
                });
              }
              // navigate("/ancillaryorder", { state: { 
              //   practiceId: row.practiceId,practiceName: row.practiceName,patientName: row.patientName,patientId: row.patientId } });
            })}
          //CS-1071 - End
          >
            <PendingActionsOutlined fontSize="small" />
          </CustomIconButton>
        )}
        {/* CS-1244 -End */}
        {/* <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="View Orders"
          color="success"
          size="small"
          variant="outlined"
          onClick={() => onViewOldOrderClick(row)}
        >
          <Wysiwyg fontSize="small" />
        </CustomIconButton> */}

        {/* <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Create Order"
          color="success"
          size="small"
          variant="outlined"
        >
          <ListAltOutlined fontSize="small" />
        </CustomIconButton> */}

        {/* <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Details"
          color="info"
          size="small"
          variant="outlined"
        >
          <AssessmentOutlined fontSize="small" />
        </CustomIconButton> */}

        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Delete"
          color="error"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canDeletePatient && row.status === PATIENT_STATUS.DRAFTED))}` }}
          //CS-1071 - Start
          onClick={() =>  handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => {
            setSelectedPatient({
              patientId: row.patientId || 0,
              practiceId: row.practiceId || 0
            })
            setConfirmDeleteOptionPopup(true)
          })}
          //CS-1071 - End
        >
          <DeleteOutlineOutlined fontSize="small" />
        </CustomIconButton>

        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Edit"
          color="info"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canEditPatient && row.status === PATIENT_STATUS.DRAFTED))}` }}
          onClick={() =>    handleActionButtonClick(`patientListActionButton-${row.patientId}`, () =>{navigate('/editPatient', { state: { patientDetails: { isPatientEdit: true, patientId: row.patientId } } })})}
        >
          <ModeOutlined fontSize="small" />
        </CustomIconButton>
        {row.status !== PATIENT_STATUS.DRAFTED && (
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Auto-Eligibility"
          color="error"
          size="small"
          variant="outlined"
          style={{ display: hideElement(!canAccessBenefitVerification || row.status === PATIENT_STATUS.CLOSED) }}
          //CS-1071 - Start
          onClick={() =>
            handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => onVerifyBenefitClick(row))
          }
          //CS-1071 - End
        >
          <VerifiedUserOutlined fontSize="small" />
        </CustomIconButton>
        )}

        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Record Tx"
          color="success"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canRecordTX && row.status === PATIENT_STATUS.ACTIVE))}` }}
          onClick={() => handleRecordTXClick(row)}
        >
          <TroubleshootOutlined fontSize="small" />
        </CustomIconButton>

        {/* CS-2075 START */}
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Request Rx"
          color="success"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canRequestRx && row.status === PATIENT_STATUS.ACTIVE && !!row.practiceId))}` }}
          onClick={() => handleActionButtonClick(`patientListActionButton-${row.patientId}`, () =>
            setRxPatient({ patientId: row.patientId, practiceId: Number(row.practiceId) })
          )}
        >
          <MedicationOutlinedIcon fontSize="small" />
        </CustomIconButton>
        {/* CS-2075 END */}

        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Close Patient"
          color="error"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canClosePatient &&  (row.status === PATIENT_STATUS.ACTIVE)) )}` }}
          onClick={() => handleClosePatient(row)}
        >
          {/* <TroubleshootOutlined fontSize="small" /> */}
          <MobileFriendlyOutlined fontSize="small"/>
        </CustomIconButton>
        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Reopen (Active)"
          color="success"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!(canReOpenPatient && row.status === PATIENT_STATUS.CLOSED ))}` }}
          onClick={() => handleActivatePatient(row)}
        >
          <ToggleOnIcon fontSize="small" />
        </CustomIconButton>

        <CustomIconButton
          tooltipPlacement="top"
          tooltipMessage="Patient Audit"
          color="warning"
          size="small"
          variant="outlined"
          style={{ display: `${hideElement(!canAuditPatient)}` }}
          
          onClick={() =>  handleActionButtonClick(`patientListActionButton-${row.patientId}`, () => handleClickPatientAudit(row) )}
          
        >
          <TrackChanges fontSize="small" />
        </CustomIconButton>


      </>
    );
  }

  const practiceOptions = useMemo(() => {
    let options: Option[] = [];
    if (practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length > 0) {
      const sortedPracticeInfo: PracticeInfo[] = sortNames(practiceByUserRoleUserSlice, 'practiceName');
      sortedPracticeInfo?.map(practice => {
        options.push({ value: practice.practiceId, label: practice.practiceName });
      });
    }
    return options;
  }, [practiceByUserRoleUserSlice]);


  const patientStatusOptions = useMemo(() => {
    let options: Option[] = [];
    if (Object.keys(PATIENT_STATUS).length > 0) {
      Object.keys(PATIENT_STATUS).forEach((key) => {
       key!==PATIENT_STATUS.DRAFTED && options.push({ value: PATIENT_STATUS[key as keyof typeof PATIENT_STATUS], label: key });
      });
    }
    return options;
  }, []);

  useEffect(() => {
    const fetchPractices = async () => {
      try {
        const response = await dispatch(getPracticesByUserRoleUserSlice(true));
        if (response) {
          setLoadingComplete(true);
        }
      } catch (error) {
        console.error("Failed to fetch practices:", error);
        setLoadingComplete(true);
      }
    };

    fetchPractices();
  }, [dispatch]);

  // CS - 1790 - Fix the issue of success & failure both toast message simultaneously shown after patient deletion
  const deletePatientbyId = async () => {
    setConfirmDeleteOptionPopup(false);
    try {
      await dispatch(deletePatient({ patientId: selectedPatient?.patientId ? selectedPatient.patientId.toString() : "" })).unwrap();
      await searchPracticesList(searchCriteria);
      handleAlert(`Patient has been deleted successfully..`, "success");
    } catch {
      // Error toast handled globally by axios interceptor (http.ts)
    }
  }


  const onClickInfoPopup = () => {
    setShowInfoPopup({ message: "", show: false, title: "" })
  }
  //CS-1244 - Start - Don't reomove this code
  //CS-1758 - Refactored: Add Patient now opens the AddNewPatientPopup
  // Manual Entry triggers the original EMR/navigate logic
  // Upload FaceSheet opens the FacesheetExtractionPopup
  const handleClickAddPatient = () => {
    if (canCreatePatientUsingFaceSheet) {
      setShowAddNewPatientPopup(true);
    } else {
      handleManualEntry();
    }
  }

  const handleManualEntry = () => {
    if (practiceByUserRoleUserSlice && practiceByUserRoleUserSlice.length === 1 && practiceByUserRoleUserSlice[0]?.isEMREnabled) {
      setOpenPracticePopup(true)
    } else if (practiceByUserRoleUserSlice && practiceByUserRoleUserSlice?.length > 1) {
      setOpenPracticePopup(true)
    } else {
      // CS-1758 - Manual add patient flow source
      navigate("/editPatient", {
        state: { patientDetails: { isPatientEdit: false, patientId: null, createPatientFlowSource: CREATE_PATIENT_FLOW_SOURCE.MANUAL } },
      })
    }
  }
  //CS-1244 - End

  useEffect(()=>{
    if(loadingComplete){
      dispatch(showHideLoadingDialog(false))
    }
  },[loadingComplete])

  const totalRecords = searchPatientList?.totalElements ?? 0;
  const patientBorderColor = isDark ? "rgba(148,163,184,0.2)" : "rgba(15,23,42,0.12)";
  const patientPanelBg = isDark ? "#141720" : "rgba(255,255,255,0.82)";
  const patientSoftBg = isDark ? "rgba(15,23,42,0.35)" : "rgba(248,250,252,0.85)";
  const patientHoverBg = isDark ? "rgba(20,184,166,0.09)" : "rgba(20,184,166,0.06)";

  const patientCardSx = {
    borderRadius: "14px",
    border: `1px solid ${patientBorderColor}`,
    backgroundColor: patientPanelBg,
    backgroundImage: "none",
    backdropFilter: "blur(8px)",
    boxShadow: isDark ? "0 12px 32px rgba(0,0,0,0.28)" : "0 12px 28px rgba(15,23,42,0.08)",
  };

  const filterPanelSx = {
    ...patientCardSx,
    p: { xs: "14px !important", md: "18px !important" },
    "& .MuiAutocomplete-root, & .MuiFormControl-root": {
      width: "100%",
      height: "42px",
      minHeight: "42px !important",
    },
    "& .MuiTextField-root": {
      height: "42px",
      minHeight: "42px !important",
    },
    "& .MuiOutlinedInput-root, & .MuiInputBase-root, & .MuiAutocomplete-inputRoot, & .MuiAutocomplete-root .MuiOutlinedInput-root": {
      minHeight: "42px !important",
      height: "42px !important",
      borderRadius: "10px !important",
      backgroundColor: `${modalTokens.inputBg} !important`,
      color: modalTokens.textPrimary,
      fontSize: "0.88rem",
      boxShadow: isDark ? "none" : "0 1px 3px rgba(0,0,0,0.06)",
      alignItems: "center",
      boxSizing: "border-box",
    },
    "& .MuiAutocomplete-root .MuiOutlinedInput-root": {
      padding: "0 38px 0 12px !important",
    },
    "& .MuiAutocomplete-root .MuiInputBase-input, & .MuiAutocomplete-input, & .MuiOutlinedInput-input": {
      paddingTop: "8px !important",
      paddingBottom: "8px !important",
      height: "24px !important",
      lineHeight: "24px !important",
      boxSizing: "border-box",
    },
    "& .MuiOutlinedInput-input": {
      paddingLeft: "12px !important",
      paddingRight: "12px !important",
    },
    "& .MuiAutocomplete-endAdornment": {
      top: "50% !important",
      transform: "translateY(-50%)",
      right: "8px !important",
    },
    "& .MuiOutlinedInput-notchedOutline, & .MuiOutlinedInput-root fieldset": {
      borderColor: `${modalTokens.inputBorder} !important`,
    },
    "& .MuiOutlinedInput-root:hover fieldset, & .MuiOutlinedInput-root.Mui-focused fieldset": {
      borderColor: `${modalTokens.accent} !important`,
      borderWidth: "1px !important",
    },
    "& .MuiOutlinedInput-root.Mui-focused": {
      boxShadow: isDark ? "none" : "0 0 0 3px rgba(20,184,166,0.12)",
    },
    "& .MuiInputBase-input": {
      color: modalTokens.textPrimary,
      fontSize: "0.88rem",
    },
    "& input::selection": {
      color: modalTokens.textPrimary,
      backgroundColor: isDark ? "rgba(20,184,166,0.28)" : "rgba(20,184,166,0.2)",
    },
    "& .MuiOutlinedInput-root:has(input:-webkit-autofill)": {
      backgroundColor: "#376c9f !important",
      "& fieldset": {
        borderColor: "#7fb1df !important",
      },
    },
    "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
      WebkitTextFillColor: "#ffffff",
      caretColor: "#ffffff",
      WebkitBoxShadow: "0 0 0 100px #376c9f inset",
      borderRadius: "10px",
      transition: "background-color 5000s ease-in-out 0s",
    },
    "& .MuiInputLabel-root": { color: isDark ? "rgba(255,255,255,0.5)" : "rgba(0,0,0,0.45)", fontSize: "0.88rem" },
    "& .MuiInputLabel-root.Mui-focused": { color: `${modalTokens.accent} !important` },
    "& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)": { transform: "translate(14px, 9px) scale(1)" },
    "& .MuiChip-root": {
      borderRadius: "999px",
      backgroundColor: isDark ? "rgba(20,184,166,0.16)" : "rgba(20,184,166,0.1)",
      color: modalTokens.accent,
      border: `1px solid ${isDark ? "rgba(20,184,166,0.26)" : "rgba(20,184,166,0.18)"}`,
      fontWeight: 600,
    },
  };

  const filterFieldLabelSx = {
    fontSize: "0.8rem",
    fontWeight: 600,
    color: modalTokens.textSecondary,
    mb: 0.7,
    height: "16px",
    lineHeight: "16px",
  };

  const patientPrimaryBtnSx = {
    ...primaryBtnSx,
    color: "#fff",
    "& .MuiTypography-root": {
      color: "#fff",
      fontWeight: 700,
    },
    "& .MuiButton-startIcon": {
      color: "#fff",
    },
  };

  const outlineBtnSx = {
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "10px",
    py: 1.05,
    px: 1.6,
    color: modalTokens.accent,
    borderColor: "rgba(20,184,166,0.55)",
    backgroundColor: isDark ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
    whiteSpace: "nowrap",
    "&:hover": {
      color: "#fff",
      borderColor: modalTokens.accentHover,
      backgroundColor: modalTokens.accentHover,
      boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
    },
  };

  const filterToggleBtnSx = {
    ...outlineBtnSx,
    color: "#00B8D9",
    borderColor: "rgba(0,184,217,0.55)",
    backgroundColor: isDark ? "rgba(0,184,217,0.08)" : "rgba(0,184,217,0.04)",
    "&:hover": {
      color: "#fff",
      borderColor: "#00B8D9",
      backgroundColor: "#00B8D9",
      boxShadow: "0 6px 22px rgba(0,184,217,0.28)",
    },
  };

  const exportMenuItemBtnSx = {
    justifyContent: "flex-start",
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.86rem",
    borderRadius: "8px",
    py: 1,
    px: 1.4,
    color: "#2dd4bf",
    borderColor: "rgba(45,212,191,0.35)",
    backgroundColor: isDark ? "rgba(20,184,166,0.13)" : "rgba(20,184,166,0.08)",
    boxShadow: "none",
    "& .MuiButton-startIcon": {
      mr: 1,
      "& svg": { fontSize: "18px" },
    },
    "&:hover": {
      color: "#fff",
      borderColor: "#2f9b8f",
      backgroundColor: "#2f9b8f",
      boxShadow: "0 10px 24px rgba(20,184,166,0.28)",
    },
    "&.Mui-disabled": {
      color: isDark ? "rgba(148,163,184,0.55)" : "rgba(100,116,139,0.7)",
      borderColor: isDark ? "rgba(148,163,184,0.18)" : "rgba(100,116,139,0.24)",
      backgroundColor: isDark ? "rgba(148,163,184,0.06)" : "rgba(100,116,139,0.06)",
    },
  };

  const patientTableSx = {
    "& .MuiTableContainer-root": {
      borderRadius: "12px",
      border: "none",
      backgroundColor: "transparent",
    },
    "& table": {
      
      borderCollapse: "collapse",
      borderSpacing: 0,
    },
    "& .MuiTableCell-root": {
      borderBottom: `1px solid ${isDark ? "rgba(148,163,184,0.14)" : "rgba(15,23,42,0.08)"}`,
      py: 1.15,
      fontSize: "0.84rem",
    },
    "& .MuiTableHead-root .MuiTableCell-root": {
      height: "42px",
    },
    "& .MuiTableHead-root .MuiTypography-root": {
      color: "#00B8D9 !important",
      fontSize: "0.78rem",
      fontWeight: 800,
      letterSpacing: "0.02em",
    },
    "& .MuiTableBody-root .MuiTableRow-root": {
      transition: "background-color 0.18s ease, box-shadow 0.18s ease",
    },
    "& .MuiTableBody-root .MuiTableRow-root:hover": {
      backgroundColor: `${patientHoverBg} !important`,
    },
    "& .MuiTableBody-root .MuiTableCell-root, & .MuiTableBody-root .MuiTypography-root": {
      color: modalTokens.textPrimary,
      fontSize: "0.84rem",
    },
    "& .MuiTableBody-root .MuiTableCell-root:first-of-type .MuiLink-root": {
      color: "#00B8D9 !important",
      fontWeight: 600,
      textDecorationColor: "rgba(0,184,217,0.45)",
    },
    "& .MuiTableBody-root .MuiTableCell-root:first-of-type .MuiLink-root:hover": {
      color: "#22d3ee !important",
      textDecorationColor: "#22d3ee",
    },
    "& .MuiIconButton-root": {
      color: isDark ? "#94a3b8" : "#475569",
      borderRadius: "8px",
      "&:hover": {
        color: modalTokens.accent,
        backgroundColor: isDark ? "rgba(20,184,166,0.12)" : "rgba(20,184,166,0.08)",
      },
    },
    "& .MuiPaginationItem-root": {
      borderColor: patientBorderColor,
      color: modalTokens.textSecondary,
      borderRadius: "8px",
      "&.Mui-selected": {
        color: "#fff",
        backgroundColor: modalTokens.accent,
        borderColor: modalTokens.accent,
      },
    },
  };

  return (
    <>
      {/* CS-1758 - Add New Patient Popup (Manual Entry / Upload FaceSheet) */}
      <AddNewPatientPopup
        open={showAddNewPatientPopup}
        onClose={() => setShowAddNewPatientPopup(false)}
        onManualEntry={handleManualEntry}
        showFacesheetOption={canCreatePatientUsingFaceSheet}
      />
      {/* CS-1148 - Start */}
      {showCreateIvrPopup.show &&
        <InfoPopup
          open={showCreateIvrPopup.show}
          content={showCreateIvrPopup.message}
          onClose={() => { setCreateIvrPopup({ message: "", show: false, title: "" });  }}
          severity="info"
          confirmButton={"Create IVR"}
          onConfirm={() =>handleActionButtonClick(`patientListActionButton-${createdPatientData.patientId}`, () => onCreateIVRClick(createdPatientData))}
          title={showCreateIvrPopup.title}
        />
      }
      {/* CS-1244 - Start */}
      {openPracticePopup && (
        <AddPatientEmrPopup
        open={openPracticePopup}
        onClose={() => setOpenPracticePopup(false)}
        practiceData={practiceByUserRoleUserSlice}
        />
      )}
      {/* CS-1244 - End */}
      {showIVRListPopup && (
        <CreateOrderIVRListPopup
          open={showIVRListPopup}
          onClose={handleClose}
          orderFromPatientList={true}
          patientId={selectedPatient?.patientId}
          practiceId={selectedPatient?.practiceId}
          patientData={selectedPatientData}
          practiceName={selectedPatientData?.practiceName}
          providerId={selectedPatient?.providerId}
        />
      )}
      {showIVRSelectionPopup &&
        <IVRPracticeSelectionPopup
          open={showIVRSelectionPopup}
          onClose={() => {
            setShowIVRSelectionPopup(false);
          }}
          patientData={selectedPatient ? { from: CAN_ACCESS_APPLICATION.PATIENT_MANAGEMENT, patientId: selectedPatient.patientId } : null}
          practiceId={selectedPatient?.practiceId}
        />
      }
      {/* Not in use as all the logic written inside one component need to remove once ancillary order is implemented */}
      {/* {showCreateOrderPopup &&
        <CreateOrderPopupForPatients
          open={showCreateOrderPopup}
          onClose={() => {
            setShowCreateOrderPopup(false);
          }}
          patientId={selectedPatient?.patientId}
          practiceId = {selectedPatient?.practiceId}
          practiceName={selectedPatient?.practiceName}
          selectedPatientData={selectedPatientData}
        />
      } */}
      {confirmDeleteOptionPopup && (
        <OptionsPopup
          open={confirmDeleteOptionPopup}
          onClose={() => setConfirmDeleteOptionPopup(false)}
          variant="confirm"
          message={`Are you sure you want to delete this patient?`}
          buttons={[
            {
              name: "Confirm",
              color: "primary",
              onClick: () => deletePatientbyId(),
            },
            { name: "Cancel", color: "secondary", onClick: () => { setConfirmDeleteOptionPopup(false) } },
          ]}
        />
      )}
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          px: { xs: 1, md: 3 },
          py: 2,
        }}
      >
        {/* <Header title="Patient List" /> */}
        <Box>
          <Collapse in={showCard} ref={filterPanelRef} onEntering={handleFilterPanelEntering} onEntered={handleFilterPanelEntered} onExited={handleFilterPanelExited}>
            <Card sx={filterPanelSx}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item md={3} xs={12}>
                    <CustomMultipleDropDown control={control} name="practiceIds" label="Practice Name" placeholderText="Select practice" options={practiceOptions} disabled={practiceOptions?.length === 1} size="small" />
                  </Grid>
                  <Grid item md={12/5} xs={12}>
                    <CustomTextField control={control} controllerName="firstName" label="First Name" placeholder="Enter first name" size="small" />
                  </Grid>
                  <Grid item md={12/5} xs={12}>
                    <CustomTextField control={control} controllerName="lastName" label="Last Name" placeholder="Enter last name" size="small" />
                  </Grid>
                  <Grid item md={11/5} xs={12}>
                    <CustomMultipleDropDown control={control} name="patientStatus" label="Patient Status" placeholderText="Select status" options={patientStatusOptions} disabled={patientStatusOptions?.length === 1} size="small" />
                  </Grid>
                  {/* <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="primaryInsurance" label="Primary Insurance Name" />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTextField control={control} controllerName="secondaryInsurance" label="Secondary Insurance Name" />
                  </Grid> */}
                  <Grid item md={2} xs={12}>
                    <Button fullWidth size="large" startIcon={<SearchOutlined />} sx={{ ...patientPrimaryBtnSx, height: "42px", py: 0 }} type="submit" removeUpperCase>
                      Search
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Card>
          </Collapse>
        </Box>
        <Box mt={2}>
          <Card sx={{ ...patientCardSx, p: { xs: "14px !important", md: "18px !important" } }}>
            <Grid container justifyContent="space-between" alignItems="center" spacing={1.2}>
              <Grid item xs={12} md>
                <Typography variant='h3' fontWeight={800} color="text.primary">Patient List</Typography>
              </Grid>
              <Grid item xs={12} md="auto">
                <Button variant="outlined" color="info" onClick={toggleFilterPanel} startIcon={<SearchOutlined />} fullWidth sx={filterToggleBtnSx} removeUpperCase>
                  {showCard ? "Hide Filters" : "Show Filters"}
                </Button>
              </Grid>
              <Grid item xs={12} md="auto">
                {canCreatePatient ?
                  <Button
                    color="info"
                    startIcon={<AddCircleOutlineOutlined />}
                    fullWidth
                    // onClick={() => navigate("/editPatient", {
                    //   state: { patientDetails: { isPatientEdit: false, patientId: null } },
                    // })
                    // }
                    onClick={withPRUGuard(() => handleClickAddPatient())} //CS-1244
                    sx={patientPrimaryBtnSx}
                    removeUpperCase
                  >
                    Add Patient
                  </Button>
                  : ""}
              </Grid>
              {canExportPatients && (
                <Grid item xs={12} md="auto">
                  {!isMobile && (
                    <Button
                      id="customized-button"
                      aria-controls={Boolean(anchorElMenu) ? "customized-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={Boolean(anchorElMenu) ? "true" : undefined}
                      variant="outlined"
                      disableElevation
                      onClick={handleMenuClick}
                      startIcon={<ExitToApp />}
                      sx={outlineBtnSx}
                      removeUpperCase
                      endIcon={
                        <Box
                          component="span"
                          sx={{
                            display: "flex",
                            transition: "transform 0.3s ease",
                            transform: anchorElMenu ? "rotate(180deg)" : "rotate(0deg)",
                            padding: "2px",
                          }}
                        >
                          <KeyboardArrowDown />
                        </Box>
                      }
                    >
                      Export
                    </Button>
                  )}
                </Grid>
              )}

              <Grid item xs={12} md="auto">
                <Box>
                  {canExportPatients && isMobile && (
                    <Box mt={1}>
                      <Button
                        color="success"
                        variant="text"
                        onClick={(event) => handleMenuClick(event)}
                        startIcon={<DownloadOutlined fontSize="small" />}
                        sx={outlineBtnSx}
                        removeUpperCase
                      >
                        Export
                      </Button>
                    </Box>
                  )}

                  <StyledMenu
                    id="customized-menu"
                    MenuListProps={{ "aria-labelledby": "customized-button" }}
                    anchorEl={anchorElMenu}
                    open={Boolean(anchorElMenu)}
                    onClose={handleMenuClose}
                    slotProps={{
                      paper: {
                        sx: {
                          width: "260px",
                          maxWidth: "90vw",
                          mt: 0.75,
                          p: 0.75,
                          borderRadius: "12px",
                          border: `1px solid ${isDark ? "rgba(0,184,217,0.3)" : "rgba(0,184,217,0.22)"}`,
                          backgroundColor: isDark ? "#141720" : "#ffffff",
                          backgroundImage: "none",
                          boxShadow: isDark
                            ? "0 18px 42px rgba(0,0,0,0.45)"
                            : "0 14px 32px rgba(15,23,42,0.14)",
                        },
                      },
                    }}
                  >
                    <Box sx={{ px: 1, mb: 1 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<CloudDownload />}
                        onClick={() => setShowPHIWarning({
                          show: true,
                          title: "PHI Warning",
                          message: (
                            <center>This export may contain Protected Health Information (PHI). Once exported, data security is your responsibility. Proceed only if you are authorized and will handle this data in compliance with HIPAA.</center>
                          ),
                          variant: "warning",
                          buttons: [
                            {
                              name: "CANCEL",
                              color: "error",
                              onClick: () => setShowPHIWarning({ show: false, message: '' })
                            },
                            {
                              name: "PROCEED",
                              color: "success",
                              onClick: () => {
                                handleExport("searchList");
                                setShowPHIWarning({ show: false, message: '' });
                              }
                            }
                          ]
                        })}
                        disabled={totalRecords > 1000}
                        sx={exportMenuItemBtnSx}
                        removeUpperCase
                      >
                        Export Search List
                      </Button>
                    </Box>


                    <Box sx={{ px: 1, mb: 1 }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        startIcon={<CloudDownload />}
                        // CS-1700 - Start
                        onClick={() => setShowPHIWarning({
                          show: true,
                          title: "PHI Warning",
                          message: (
                            <center>This export may contain Protected Health Information (PHI). Once exported, data security is your responsibility. Proceed only if you are authorized and will handle this data in compliance with HIPAA.</center>
                          ),
                          variant: "warning",
                          buttons: [
                            {
                              name: "CANCEL",
                              color: "error",
                              onClick: () => setShowPHIWarning({ show: false, message: '' })
                            },
                            {
                              name: "PROCEED",
                              color: "success",
                              onClick: () => {
                                handleExport("details");
                                setShowPHIWarning({ show: false, message: '' });
                              }
                            }
                          ]
                        })}
                        // CS-1700 - End
                        disabled={totalRecords > 1000}
                        sx={exportMenuItemBtnSx}
                        removeUpperCase
                      >
                        Export Details List
                      </Button>
                    </Box>

                    {totalRecords > 1000 && (
                      <Box
                        sx={{
                          mx: 1,
                          p: 1.5,
                          mt: 1,
                          backgroundColor: "warning.light",
                          borderRadius: 1,
                          color: "warning.contrastText",
                        }}
                      >
                        <Typography variant="body2">
                          Export is available only when the list contains 1,000 records or fewer.
                          Maximum export size: 1000 records.
                        </Typography>
                      </Box>
                    )}
                  </StyledMenu>
                </Box>
              </Grid>




            </Grid>
            <Table
              columns={columns}
              rows={loadingComplete ? formattedPatientRows || [] : []}
              actionComponent={(row: PatientInfo) => actionComponent(row)}
              emptyText="No Patient(s) Found"
              pageNumber={handlePagination}
              uniqueValue="patientId"
              totalPages={loadingComplete ? searchPatientList?.totalPages : 0}
              totalElementText={"Records: " + ((loadingComplete && searchPatientList?.totalElements) ? searchPatientList?.totalElements : "0")}
              currentPageNumber={searchCriteria.currentPage - 1}
              showMenu={true}
              sortableColumns={
                isSurgicalPracticesAvailable
                  ? patientListSort.sortableColumns
                  : patientListSort.sortableColumns.filter((columnId) => columnId !== "dateOfSurgery")
              }
              serverSideSorting
              onSortChange={handleTableSort}
              controlledSortColumn={patientListSort.controlledColumn(searchCriteria.sortBy)}
              controlledSortOrder={searchCriteria.sortOrder ?? null}
              //CS-1071
              currentPageKey={"patientList"}
              activeButtonId={activeButtonId}
              sx={patientTableSx}
              //
              // CS-1555 -Start
              onRowClick={handleRowNavigateToDetails}
              clickableCards={true}
              // CS-1555 -End
            />
          </Card>
        </Box>
        <RecordPastOrderPopup
          onClose={handleRecordPastOrderPopup}
          open={showRecordPastOrderPopup}
          patientData={selectedPatientData}
          patientId={selectedPatient?.patientId}
          practiceId={selectedPatient?.practiceId}
        />
      </Box>

      {showOptionPopup.show &&
        <OptionsPopup
          open={showOptionPopup.show}
          onClose={() => setShowOptionsPopup({ message: "", show: false })}
          variant={showOptionPopup.variant}
          message={<>{showOptionPopup.message}</>}
          buttons={showOptionPopup.buttons}
          title={showOptionPopup.title}
          obj={showOptionPopup.obj}
        />
      }

      {showInfoPopup.show &&
        <InfoPopup
          open={showInfoPopup.show}
          content={showInfoPopup.message}
          onClose={onClickInfoPopup}
          severity="info"
          title={showInfoPopup.title}
        />
      }
      {showEligibilityPopup && (
        <PatientEligibilityPopUp
          patientData={selectedPatient}
          open={showEligibilityPopup}
          onClose={() => {setShowEligibilityPopup(false);setVerifyBenefitClick(false);setPatientData(null);setSelectedPatient(null)}}
        />
      )}
      {/* CS-1700 - Start */}
      {showPHIWarning.show &&
        <WarningPopup
          open={showPHIWarning.show}
          onClose={() => setShowPHIWarning({ show: false, message: '' })}
          title={showPHIWarning.title}
          message={<>{showPHIWarning.message}</>}
          variant={showPHIWarning.variant}
          buttons={showPHIWarning.buttons}
        />
      }
      {/* CS-1700 - End */}
      {showPRUWarning.show && (
        <WarningPopupNew
          open={showPRUWarning.show}
          onClose={() => setShowPRUWarning({ show: false, message: '' })}
          title={showPRUWarning.title}
          message={<>{showPRUWarning.message}</>}
          variant={showPRUWarning.variant}
          buttons={showPRUWarning.buttons}
        />
      )}
      <CompletePracticeRegistrationModal
        open={registrationModalOpen}
        onClose={() => setRegistrationModalOpen(false)}
      />
      <PatientRequestRx patient={rxPatient} onClose={() => setRxPatient(null)} /> {/* CS-2075 */}
    </>
  );

}

export default PatientsList;
